// Cookie Banner Focus
let keyboardIntent = false;

window.addEventListener("keydown", function (e) {
  if (e.key === "Tab") {
    keyboardIntent = true;
    maybeFocusBanner();
  }
});

function isNewsletterVisible() {
  // Seleziona tutti gli elementi .kl-private-reset-css-Xuajs1 NON dentro al footer
  const modals = [...document.querySelectorAll('.kl-private-reset-css-Xuajs1')].filter(
    el => !el.closest('footer')
  );

  // Verifica se almeno uno è visibile
  return modals.some(el => el.offsetParent !== null);
}

function maybeFocusBanner() {
  if (!keyboardIntent) return;

  if (!isNewsletterVisible()) {
    tryFocusBanner();
  }
}

function tryFocusBanner() {
  const banner = document.querySelector("#onetrust-banner-sdk");
  if (banner && !banner.dataset.focused) {
    const firstBtn = banner.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (firstBtn) {
      banner.setAttribute("role", "dialog");
      banner.setAttribute("aria-label", "Banner informativa cookie");
      firstBtn.focus();
      banner.dataset.focused = "true";
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  maybeFocusBanner();

  const body = document.body;

  const modalObserver = new MutationObserver(() => {
    if (!isNewsletterVisible()) {
      maybeFocusBanner();
    }
  });

  modalObserver.observe(body, { childList: true, subtree: true });

  const bannerObserver = new MutationObserver(() => {
    maybeFocusBanner();
  });

  bannerObserver.observe(body, { childList: true, subtree: true });
});



// Open header item on click
document.addEventListener("DOMContentLoaded", function () {
  const expandableLinks = document.querySelectorAll(".js-expandable");

  function closeAllMeganavs() {
    document.querySelectorAll(".c-header__link.is-open").forEach((el) => {
      el.classList.remove("is-open");
      const trigger = el.querySelector(".js-expandable");
      if (trigger) {
        trigger.setAttribute("aria-expanded", "false");
      }
    });
  }

  expandableLinks.forEach((link) => {
    link.addEventListener("click", function (event) {
      event.stopPropagation();

      const li = this.closest(".c-header__link");
      const isOpen = li.classList.contains("is-open");

      closeAllMeganavs();

      if (!isOpen) {
        li.classList.add("is-open");
        this.setAttribute("aria-expanded", "true");

        const meganav = li.querySelector(".c-meganav");
        if (meganav) meganav.focus();
      }
    });
  });

  // Chiudi la meganav se premi fuori
  document.addEventListener("mouseup", function (event) {
    const isInsideHeader = event.target.closest(".c-header__link");
    const isInsideMeganav = event.target.closest(".c-meganav");

    if (!isInsideHeader && !isInsideMeganav) {
      closeAllMeganavs();
    }
  });

  // Chiudi la meganav se premi ESC
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.key === "Esc") {
      closeAllMeganavs();
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const toggleBtn = document.querySelector(".js-header-search");
  const searchForm = document.querySelector(".js-header-search-form");

  toggleBtn?.addEventListener("click", function () {
    const isVisible = searchForm.classList.toggle("is-visible");
    searchForm.setAttribute("aria-hidden", !isVisible);
  });
});

// Doofinder Search Accessibility
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutations, obs) => {
    let modified = false;

    // 1- Pulsante chiudi
    const closeBtn = document.querySelector(".dfd-close-button");
    const searchPlaceholder = document.querySelector("#boost-sd__search-widget-init-input-0");
    if (closeBtn) {
      closeBtn.setAttribute("aria-label", "Chiudi");
      modified = true;
    }

    if(searchPlaceholder){
        searchPlaceholder.setAttribute("placeholder", "Cerca");
    }

    // 2- Pulsante invia invisibile
    const submitBtn = document.querySelector(
      '.dfd-searchbox input[type="submit"]'
    );
    if (submitBtn && !submitBtn.getAttribute("aria-label")) {
      submitBtn.setAttribute("aria-label", "Cerca");
      modified = true;
    }

    // 3- Pulsanti "Remove suggestion"
    document
      .querySelectorAll('[aria-label^="Remove suggestion"]')
      .forEach((btn) => {
        const term = btn.getAttribute("aria-label")?.split(":")[1]?.trim();
        if (term) {
          btn.setAttribute("aria-label", "Rimuovi suggerimento: " + term);
          modified = true;
        }
      });

    // 4. Rimuovere aria-label dai suggerimenti tipo "Suggestion: Earl Grey"
    document
      .querySelectorAll(
        '.dfd-suggestion-link button[aria-label^="Suggestion:"]'
      )
      .forEach((btn) => {
        btn.removeAttribute("aria-label");
        modified = true;
      });

    // 5. Rimuovere aria-labelledby dai link dei prodotti
    document
      .querySelectorAll(".dfd-card-content a[aria-labelledby]")
      .forEach((link) => {
        link.removeAttribute("aria-labelledby");
        modified = true;
      });

    if (closeBtn && submitBtn) {
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Remove duplicate all aria-label & aria-labelledby.
document.addEventListener("DOMContentLoaded", () => {
  const selector = '[id^="df-hook-layer-"].dfd-layer.dfd-ext';

  function cleanAccessibilityAttributes(context) {
    const suggestionButtons = context.querySelectorAll('.dfd-suggestion-link button[aria-label]');
    suggestionButtons.forEach(btn => {
      btn.removeAttribute('aria-label');
    });

    const suggestions = context.querySelectorAll('.dfd-suggestion-link[aria-label]');
    suggestions.forEach(el => el.removeAttribute('aria-label'));

    const productLinks = context.querySelectorAll('.dfd-card-link[aria-label]');
    productLinks.forEach(link => {
      link.removeAttribute('aria-label');
    });
  }

  const observer = new MutationObserver(() => {
    const layer = document.querySelector(selector);
    if (layer) {
      cleanAccessibilityAttributes(layer);

      // Sub-observer to monitor future dynamic content inside the layer
      const innerObserver = new MutationObserver(() => {
        cleanAccessibilityAttributes(layer);
      });

      innerObserver.observe(layer, {
        childList: true,
        subtree: true,
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



// Subscribe Modal Buttons lang.
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll('button.klaviyo-close-form[aria-label="Close dialog"]')
      .forEach((btn) => {
        btn.setAttribute("aria-label", "Chiudi finestra");
      });

    document
      .querySelectorAll("button.klaviyo-close-form svg title")
      .forEach((titleEl) => {
        if (titleEl.textContent.trim().toLowerCase() === "close dialog") {
          titleEl.textContent = "Chiudi finestra";
        }
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Glider.js buttons lang.
document.addEventListener("DOMContentLoaded", function () {
  const updateSliderAccessibility = () => {
    // FRECCE
    document
      .querySelectorAll('.glider-prev[aria-label="Previous"]')
      .forEach((btn) => {
        btn.setAttribute("aria-label", "Slide precedente");
      });
    document
      .querySelectorAll('.glider-next[aria-label="Next"]')
      .forEach((btn) => {
        btn.setAttribute("aria-label", "Slide successiva");
      });

    // DOTS
    document.querySelectorAll(".glider-dots").forEach((dotGroup) => {
      const dots = dotGroup.querySelectorAll(".glider-dot");
      const total = dots.length;

      dotGroup.setAttribute("role", "tablist"); // opzionale, migliora semantica

      dots.forEach((dot, index) => {
        const current = index + 1;
        dot.setAttribute("aria-label", `Slide ${current} di ${total}`);
        dot.setAttribute(
          "aria-selected",
          dot.classList.contains("active") ? "true" : "false"
        );
      });
    });
  };

  const observer = new MutationObserver(updateSliderAccessibility);
  observer.observe(document.body, { childList: true, subtree: true });

  updateSliderAccessibility();
});

// The screen reader will read the disclaimer before the subscribe button and combine it by aria-describedby attribute.
document.addEventListener("DOMContentLoaded", function () {
  const disclaimer = document.querySelector('[id^="rich-text-"]');
  const emailInput = document.querySelector('input[type="email"]');

  if (disclaimer && emailInput) {
    disclaimer.setAttribute("id", "klaviyo-newsletter-disclaimer");
    emailInput.setAttribute(
      "aria-describedby",
      "klaviyo-newsletter-disclaimer"
    );
  }
});

// Translate the invalid email errors, we can also edit it from Kalviyo config.
// document.addEventListener("DOMContentLoaded", function () {
//   const translations = {
//     "This email is invalid": "L'indirizzo email non è valido",
//     "This field is required": "Questo campo è obbligatorio",
//   };

//   const observer = new MutationObserver(() => {
//     document.querySelectorAll(".klaviyo-form .needsclick").forEach((el) => {
//       const txt = el.textContent.trim();
//       if (translations[txt]) {
//         el.textContent = translations[txt];
//       }
//     });
//   });

//   const klForm = document.querySelector(".klaviyo-form");
//   if (klForm) {
//     observer.observe(klForm, {
//       childList: true,
//       subtree: true,
//     });
//   }
// });

// Add IDs to the main sections to work with skip-links.liquid
document.addEventListener("DOMContentLoaded", () => {
  // const header = document.querySelector("header, .c-header__nav");
  const main = document.querySelector("main, .main-content, [role=main]");
  // const footer = document.querySelector("footer, .c-footer");

  // if (header && !header.id) header.id = "main-menu";
  if (main && !main.id) main.id = "main-content";
  // if (footer && !footer.id) footer.id = "footer";
});

// GliderJS Convert from Div to Anchor
document.addEventListener("DOMContentLoaded", () => {
  const slides = document.querySelectorAll('div[data-pf-type="Slide2"]');

  slides.forEach((slide) => {
    const glideContainer = slide.querySelector(".glide-container");
    if (!glideContainer) return;

    const allAnchors = slide.querySelectorAll("a");
    const hrefs = [...allAnchors].map((a) => a.getAttribute("href"));

    // 1- solo un <a> → esci
    if (hrefs.length === 1) return;

    // 2- più <a> ma href diversi → esci
    const uniqueHrefs = [...new Set(hrefs.filter(Boolean))]; // Rimuove href nulli e trova href unici
    if (uniqueHrefs.length > 1) return;

    // Calcolo href e aria-label
    const href = slide.getAttribute("data-href") || uniqueHrefs[0] || "#";
    const title = slide.querySelector("h3")?.innerText?.trim() || "collezione";
    const ariaLabel = `Scopri di più su ${title}`;

    // Rimuove tutti i <a> dentro il container e li trasforma in <span>
    glideContainer.querySelectorAll("a").forEach((anchor) => {
      const span = document.createElement("span");
      span.innerHTML = anchor.innerHTML;
      span.className = anchor.className;
      span.setAttribute("role", "presentation");
      span.setAttribute("aria-hidden", "true");
      span.style.pointerEvents = "none";
      anchor.replaceWith(span);
    });

    // Gestione degli alt nelle immagini
    glideContainer.querySelectorAll("img").forEach((img) => {
      img.setAttribute("alt", "");
    });

    // Wrappa tutto in un nuovo <a>
    const anchor = document.createElement("a");
    anchor.href = href;
    anchor.setAttribute("aria-label", ariaLabel);
    anchor.style.display = "block";
    anchor.style.height = "100%";
    anchor.style.width = "100%";
    anchor.innerHTML = glideContainer.innerHTML;

    // Pulisce e inserisce nuovo contenuto
    glideContainer.innerHTML = "";
    glideContainer.appendChild(anchor);
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//     function enhanceAriaLabelsOnSliderButtons() {
//         const slides = document.querySelectorAll('[data-pf-type="Slide2"]');

//         slides.forEach(slide => {
//             const heading = slide.querySelector('h3 span')?.textContent?.trim();
//             const link = slide.querySelector('a');

//             if (link && heading) {
//             const baseText = "Scopri di più su ";
//             link.setAttribute("aria-label", `${baseText}${heading}`);
//             }
//         });
//     }
//     enhanceAriaLabelsOnSliderButtons();
// });


// Lighthouse iframe title error - not required but to get the full points.
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("iframe:not([title])").forEach((iframe) => {
    iframe.setAttribute("title", "Contenuto tecnico non interattivo");
  });
});

// Add aria-expanded to Accordion - Etichettatura ambientale
document.addEventListener("DOMContentLoaded", () => {
  const accordionButtons = document.querySelectorAll(
    '[data-pf-type="Accordion.Header"]'
  );

  accordionButtons.forEach((button) => {
    const isActive = button.getAttribute("data-active") === "true";
    button.setAttribute("aria-expanded", isActive.toString());

    button.addEventListener("click", () => {
      const nowActive = button.getAttribute("data-active") === "true";
      button.setAttribute("aria-expanded", (!nowActive).toString());
    });
  });
});

// Add aria selected to Tab buttons - Twinings Corner
document.addEventListener("DOMContentLoaded", () => {
  const regionButtons = document.querySelectorAll("[data-pf-tab-active]");

  regionButtons.forEach((btn) => {
    btn.setAttribute("role", "tab");
    const isActive = btn.getAttribute("data-pf-tab-active") === "true";
    btn.setAttribute("aria-selected", isActive ? "true" : "false");
    btn.addEventListener("click", () => {
      regionButtons.forEach((b) => b.setAttribute("aria-selected", "false"));
      btn.setAttribute("aria-selected", "true");
    });
  });

  // Optional - Add to the container role="tablist" to insure that the buttons inside works as tabs.
  const container = regionButtons[0]?.closest('[data-pf-type="TabsMenu"]');
  if (container) {
    container.setAttribute("role", "tablist");
  }
});

// Add Dynamic aria-label to all anchors instead to do it manually - Twinings Corner
document.addEventListener("DOMContentLoaded", () => {
  // Seleziona tutti i <a> con testo "Vai al punto vendita"
  const links = Array.from(document.querySelectorAll("a.c-btn")).filter(
    (link) =>
      link.textContent.trim().toLowerCase().includes("vai al punto vendita")
  );

  links.forEach((link) => {
    // Get the title from the h3
    const row = link.closest('[data-pf-type="Row"]');

    if (!row) return;

    const h3 = row.querySelector("h3");

    if (!h3) return;

    const storeName = h3.textContent.trim();
    const label = `Vai al punto vendita ${storeName}`;

    link.setAttribute("aria-label", label);
  });
});

// Add Dynamic aria-label to all anchors instead to do it manually - Prodotti
document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(
    '[data-pf-type="CollectionViewDetails"]'
  );

  links.forEach((link) => {
    const collectionBox = link.closest('[data-pf-type="CollectionBox"]');
    if (!collectionBox) return;

    const titleElement = collectionBox.querySelector("h3");
    if (!titleElement) return;

    const collectionName = titleElement.textContent.trim();
    const ariaLabel = `Vai alla collezione ${collectionName}`;

    link.setAttribute("aria-label", ariaLabel);
  });
});

// Adjust Product Card with an unique anchor to all the card and remove the other.
document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll('[data-pf-type="CollectionBox"]');

  boxes.forEach((box) => {
    const image = box.querySelector("img");
    if (image) {
      image.alt = "";
    }
    const link = box.querySelector('[data-pf-type="CollectionViewDetails"]');
    if (!link) return;

    const href = link.getAttribute("href");

    box.querySelectorAll("a").forEach((a) => {
      const span = document.createElement("span");
      span.innerHTML = a.innerHTML;
      span.className = a.className;
      span.setAttribute("role", "presentation");
      span.setAttribute("aria-hidden", "true");
      span.style.pointerEvents = "none";
      a.replaceWith(span);
    });

    const wrapper = document.createElement("a");
    wrapper.href = href;
    wrapper.setAttribute(
      "aria-label",
      link.getAttribute("aria-label") || "Vai alla collezione"
    );
    wrapper.className = "collection-card-link";
    wrapper.style.display = "block";
    wrapper.style.textDecoration = "none";
    wrapper.style.color = "inherit";

    while (box.firstChild) {
      wrapper.appendChild(box.firstChild);
    }

    box.appendChild(wrapper);
  });
});

// Convert Accordion to button and add aria-expand - Infusi Collection Page ( CSS Added )
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".js-accordion");

  accordions.forEach((accordion) => {
    const triggerDiv = accordion.querySelector(".js-accordion-trigger");
    const content = accordion.querySelector(".js-accordion-content");

    if (!triggerDiv || !content) return;

    const button = document.createElement("button");
    button.setAttribute("type", "button");
    button.className = triggerDiv.className;
    button.innerHTML = triggerDiv.innerHTML;
    button.setAttribute("aria-expanded", "false");
    button.setAttribute(
      "aria-controls",
      "accordion-" + Math.random().toString(36).substr(2, 9)
    );

    triggerDiv.replaceWith(button);

    content.id = button.getAttribute("aria-controls");
    // content.hidden = true;

    button.addEventListener("click", () => {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!isExpanded));
      // content.hidden = isExpanded;
    });
  });
});

// Convert h4 to p to rispect heading elements sequential descending order.
document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(
      "h4.product__subtitle--small.product-collection__subtitle"
    )
    .forEach((h4) => {
      const p = document.createElement("p");
      p.className = h4.className;
      p.style.fontWeight = "bold";
      p.innerHTML = h4.innerHTML;
      h4.replaceWith(p);
    });
});

// Add selected to tab button - Contatti
document.addEventListener("DOMContentLoaded", () => {
  const tabMenus = document.querySelectorAll('[data-pf-type="TabsMenu"]');

  tabMenus.forEach((menu) => {
    const buttons = menu.querySelectorAll('[data-pf-type="TabHeader"]');

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        buttons.forEach((b) => {
          b.setAttribute("data-pf-tab-active", "false");
          b.removeAttribute("selected");
        });

        btn.setAttribute("data-pf-tab-active", "true");
        btn.setAttribute("selected", "");
      });
    });

    buttons.forEach((btn) => {
      if (btn.getAttribute("data-pf-tab-active") === "true") {
        btn.setAttribute("selected", "");
      } else {
        btn.removeAttribute("selected");
      }
    });
  });
});

// Contatti Form ( CSS Applied )
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".globo-form-app").forEach((form) => {
    // Add role="alert" to the errors.
    form.querySelectorAll(".help-block.error").forEach((error) => {
      error.setAttribute("role", "alert");
    });

    // X as Button and add aria-label to close the success message.
    form.querySelectorAll(".dismiss").forEach((dismiss) => {
      if (dismiss.tagName.toLowerCase() !== "button") {
        const button = document.createElement("button");
        button.type = "button";
        button.className = dismiss.className;
        button.setAttribute("aria-label", "Chiudi");
        button.innerHTML = dismiss.innerHTML;
        button.addEventListener("click", () => dismiss.click());
        dismiss.replaceWith(button);
      }
    });

    // Required checkbox validation.
    const submitButton = form.querySelector('button[type="submit"]');
    if (!submitButton) return;

    submitButton.addEventListener("click", (e) => {
      let valid = true;

      form
        .querySelectorAll('input[type="checkbox"][data-type="acceptTerms"]')
        .forEach((checkbox) => {
          const container = checkbox.closest(".globo-form-control");
          const messageBox = container.querySelector(".messages");

          if (!checkbox.checked) {
            valid = false;

            if (!messageBox.querySelector("[data-generated]")) {
              const errorMsg = document.createElement("p");
              errorMsg.className = "help-block error";
              errorMsg.setAttribute("role", "alert");
              errorMsg.setAttribute("data-generated", "true");
              errorMsg.textContent = "Seleziona questa casella per procedere.";
              messageBox.appendChild(errorMsg);
            }
          } else {
            messageBox
              .querySelectorAll("[data-generated]")
              .forEach((el) => el.remove());
          }
        });

      if (!valid) e.preventDefault();
    });
  });
});


// Dynamic inret attribute
document.addEventListener("DOMContentLoaded", function () {
  function updateHeaderAccessibility() {
    const mobileHeader = document.querySelector('.js-header-mobile');
    const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

    if (mobileHeader) {
      if (isDesktop) {
        mobileHeader.setAttribute('inert', '');
      } else {
        mobileHeader.removeAttribute('inert');
      }
    }
  }

  updateHeaderAccessibility();
  window.addEventListener('resize', updateHeaderAccessibility);
});

// Show Disclaimer text before input
document.addEventListener("DOMContentLoaded", () => {
  const targetFormId = "klaviyo-form-QRZ3GB";

  const observer = new MutationObserver((mutations, obs) => {
    const form = document.querySelector(`[data-testid="${targetFormId}"]`);
    if (form) {
      const mainWrapper = form.querySelector('div.kl-private-reset-css-Xuajs1');
      if (!mainWrapper) return;

      const privacyRow = mainWrapper.querySelector('[id^="rich-text-"]')?.closest('[data-testid="form-row"]');
      const inputRow = mainWrapper.querySelector('[data-testid="form-row"]');

      if (privacyRow && inputRow && privacyRow !== inputRow) {
        mainWrapper.insertBefore(privacyRow, inputRow);
      }

      // Disattiva l'observer una volta fatto
      obs.disconnect();
    }
  });

  // Avvia osservazione del body
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Add aria-label to all blocks with heading and button "Scopri di piu'"
document.addEventListener('DOMContentLoaded', () => {
  function addAriaLabelToLearnMoreButton() {
  const blocks = document.querySelectorAll('[data-pf-type="Block"]');

  blocks.forEach((block) => {
    const link = block.querySelector('a');
    const heading = block.querySelector('h1, h2, h3, h4, h5, h6');

    if (
      link &&
      heading &&
      link.textContent.trim().toLowerCase().includes('scopri di più')
    ) {
      const headingText = heading.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `Scopri di più su ${headingText}`);
      }
    }
  });
  }
  addAriaLabelToLearnMoreButton();
});

// Add empty alt text for decorative images.
document.addEventListener('DOMContentLoaded', () => {
  function ensureAllImagesHaveAlt() {
    const images = document.querySelectorAll('img');

    images.forEach(img => {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
      }
    });
  }
  ensureAllImagesHaveAlt()
});

// Add aria-label to all blocks with heading and button "Vai al punto vendita'"
document.addEventListener('DOMContentLoaded', () => {
  function addAriaLabelToGoToStoreButton() {
  const blocks = document.querySelectorAll('[data-pf-type="Row"]');

  blocks.forEach((block) => {
    const link = block.querySelector('a');
    const heading = block.querySelector('h1, h2, h3, h4, h5, h6');

    if (
      link &&
      heading &&
      link.textContent.trim().toLowerCase().includes('vai al punto vendita')
    ) {
      const headingText = heading.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `Vai al punto vendita ${headingText}`);
      }
    }
  });
  }
  addAriaLabelToGoToStoreButton();
});

// Add aria-label to BuyFromAmazon Button | Collection and Single Product pages.
document.addEventListener("DOMContentLoaded", () => {
  const amazonLinks = Array.from(document.querySelectorAll('a')).filter(a =>
    a.textContent.trim() === 'Acquista ora su Amazon'
  );

  amazonLinks.forEach(link => {
    const bannerContainer = link.closest('.c-banner.c-banner--small') || link.closest('.product.product--detail')

    if (bannerContainer) {
      const heading = bannerContainer.querySelector('h1');

      if (heading) {
        const headingText = heading.textContent.trim();
        link.setAttribute('aria-label', `Acquista ora su Amazon ${headingText}`);
      }
    }
  });
});


// Clean product details from anchor without href.
document.addEventListener("DOMContentLoaded", () => {
  const anchors = document.querySelectorAll('.product.product--detail a');

  anchors.forEach(anchor => {
    if (!anchor.hasAttribute('href')) {
      const parent = anchor.parentNode;

      const paragraph = document.createElement('span');
      paragraph.textContent = anchor.textContent;
      paragraph.style.fontWeight = 'bold';

      anchor.classList.remove('underline');

      parent.replaceChild(paragraph, anchor);
    }
  });
});

// Add aria-label to all blocks with heading and button "Vai alla ricetta"
document.addEventListener('DOMContentLoaded', () => {
  function addAriaLabelToShowReciepeButtons() {
  const blocks = document.querySelectorAll('[data-pf-type="Column"]');

  blocks.forEach((block) => {
    const link = block.querySelector('a');
    const heading = block.querySelector('h1, h2, h3, h4, h5, h6');

    if (
      link &&
      heading &&
      link.textContent.trim().toLowerCase().includes('vai alla ricetta')
    ) {
      const headingText = heading.textContent.trim();

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `Vai alla ricetta di ${headingText}`);
      }
    }
  });
  }
  addAriaLabelToShowReciepeButtons();
});


// Add Unique anchor element e transform all intern anchors to div.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-href][data-target]').forEach(originalDiv => {
    const href = originalDiv.getAttribute('data-href');
    if (!href) return;

    // Se c'è un <a> interno con stesso href, lo trasformo in <div>
    const innerAnchor = originalDiv.querySelector(`a[href="${href}"]`)
    if (innerAnchor) {
      const safeDiv = document.createElement('div');

      // Copia attributi tranne href
      Array.from(innerAnchor.attributes).forEach(attr => {
        if (attr.name !== 'href') {
          safeDiv.setAttribute(attr.name, attr.value);
        }
      });

      safeDiv.innerHTML = innerAnchor.innerHTML;
      innerAnchor.replaceWith(safeDiv);
    }

    // Creo <a> esterno
    const newAnchor = document.createElement('a');
    newAnchor.href = href;
    newAnchor.style.width = '100%';


    // Copia attributi tranne data-href
    Array.from(originalDiv.attributes).forEach(attr => {
      if (attr.name !== 'data-href') {
        newAnchor.setAttribute(attr.name, attr.value);
      }
    });

    while (originalDiv.firstChild) {
      newAnchor.appendChild(originalDiv.firstChild);
    }

    originalDiv.parentNode.replaceChild(newAnchor, originalDiv);
  });

  // 3. Rimuovuere tabindex="0" da splide__slide
  const removeTabindexFromSplide = () => {
    document.querySelectorAll('.splide__slide[tabindex="0"]').forEach(el => {
      console.log({el})
      el.removeAttribute('tabindex');
    });
  };

  removeTabindexFromSplide();

  const observer = new MutationObserver(removeTabindexFromSplide);
  observer.observe(document.body, { childList: true, subtree: true });
});


// Close icon | Contact us
document.addEventListener('DOMContentLoaded', () => {
 function replaceDismissWithButton(dismissEl) {
    const icon = dismissEl.innerHTML;

    const button = document.createElement('button');
    button.setAttribute('type', 'button');
    button.setAttribute('aria-label', 'Chiudi');
    button.className = dismissEl.className;
    button.innerHTML = icon + ' <span class="sr-only">Chiudi</span>';

    const onclick = dismissEl.getAttribute('onclick');
    if (onclick) button.setAttribute('onclick', onclick);

    dismissEl.replaceWith(button);
  }

  function observeDismissButtons() {
    const observer = new MutationObserver(() => {
      const dismissElements = document.querySelectorAll('.dismiss');
      dismissElements.forEach(el => {
        if (el.tagName.toLowerCase() !== 'button') {
          replaceDismissWithButton(el);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  observeDismissButtons();
});


// Add Twinings card to all pages that contains hero part.
document.addEventListener("DOMContentLoaded", () => {
  const twiningsHero = document.querySelector('div[data-pf-type="Section"]#twinings-hero');
  if (!twiningsHero) return;

  const firstColumn = twiningsHero.querySelector('div[data-pf-type="Column"]');
  if (!firstColumn) return;

  const computedStyle = window.getComputedStyle(firstColumn);
  const backgroundImage = computedStyle.getPropertyValue("background-image");

  if (!backgroundImage || backgroundImage === "none") return;

  firstColumn.classList.add("twinings-card-container");

  const firstChildDiv = Array.from(firstColumn.children).find(child => child.tagName === "DIV");

  if (firstChildDiv) {
    firstChildDiv.classList.add("twinings-card");
  }
});


// Klaviyo - Translate popup errors 
document.addEventListener("DOMContentLoaded", () => {
  const translations = {
    "This field is required": "Questo campo è obbligatorio",
    "This email is invalid": "L'indirizzo email non è valido"
  };

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const errors = node.querySelectorAll('.klaviyo_field_error, .k-invalid, .needsclick span');
          errors.forEach(el => {
            const text = el.textContent?.trim();
            if (text && translations[text]) {
              el.textContent = translations[text];
            }
          });
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});


// Clean all aria-label and alt content from html element ( es. <br )
document.addEventListener("DOMContentLoaded", () => {
  function cleanAriaLabelAndAlt() {
    const stripHtml = (html) => {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    };

    const ariaElements = document.querySelectorAll('[aria-label]');
    ariaElements.forEach((el) => {
      const original = el.getAttribute('aria-label');
      const cleaned = stripHtml(original);
      if (original !== cleaned) {
        el.setAttribute('aria-label', cleaned);
      }
    });

    const imgElements = document.querySelectorAll('img[alt]');
    imgElements.forEach((img) => {
      const original = img.getAttribute('alt');
      const cleaned = stripHtml(original);
      if (original !== cleaned) {
        img.setAttribute('alt', cleaned);
      }
    });
  }
  cleanAriaLabelAndAlt();
});

document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations, obs) => {
    const form = document.querySelector('.klaviyo-form-QRZ3GB');
    if (!form) return;

    const subscribeButton = form.querySelector('button[type="button"]');
    if (subscribeButton) {
      subscribeButton.type = 'submit';
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

